import { mergeAircraftTelemetry, mergeDockTelemetry } from '/@/utils/aircraft-detail-metrics.mjs'
import { InjectionKey } from 'vue'
import { ActionTree, createStore, GetterTree, MutationTree, Store, StoreOptions, useStore } from 'vuex'
import { EDeviceTypeName } from '../types'
import { Device, DeviceHms, DeviceOsd, DeviceStatus, DockOsd, GatewayOsd, OSDVisible } from '../types/device'
import { getLayers } from '/@/api/layer'
import { LayerType } from '/@/types/mapLayer'
import { WaylineFile } from '/@/types/wayline'
import { DevicesCmdExecuteInfo } from '/@/types/device-cmd'
import { setAlgorithmTaskStatus, getAlgorithmTaskListPageVo } from '/@/api/alarm'
import { getWaylineJobs, getFlyAlgorithmTaskList } from '/@/api/wayline'
import { ELocalStorageKey, ERouterName } from '/@/types/enums'
import { RouteRecordRaw } from 'vue-router'
import { BackendMenuNode, buildAsyncRoutes, enhanceBackendMenuList, readStoredMenuList } from '/@/utils/menu-runtime'

const initStateFunc = () => ({
  sidebarRouters: [] as RouteRecordRaw[],
  speakerAudio: {
    md5: '',
    progress: { percent: 100, step_key: 'play' },
    psdk_index: 2,
    status: 'success'
  },
  speakerVolume: {
    volume: 100,
  },
  isPowered: false,
  Layers: [
    {
      name: 'default',
      id: '',
      is_distributed: true,
      elements: [],
      is_check: false,
      is_select: false,
      type: 1
    },
    {
      name: 'share',
      id: '',
      is_distributed: true,
      elements: [],
      is_check: false,
      is_select: false,
      type: 2
    }
  ],
  layerBaseInfo: {} as {
    [key:string]:string
  },
  drawVisible: false,
  livestreamOthersVisible: false,
  livestreamAgoraVisible: false,
  coverList: [

  ] as any,
  wsEvent: {
    mapElementCreat: {},
    mapElementUpdate: {},
    mapElementDelete: {}
  },
  deviceStatusEvent: {
    deviceOnline: {} as DeviceStatus,
    deviceOffline: {}
  },
  markerInfo: {
    coverMap: {} as {
      [sn: string]: any
    },
    pathMap: {} as {
      [sn: string]: any[]
    }
  },
  deviceState: {
    // remote controller, dock
    gatewayInfo: {} as {
      [sn: string]: GatewayOsd
    },
    // drone
    deviceInfo: {} as {
      [sn: string]: DeviceOsd
    },
    dockInfo: {} as {
      [sn: string]: DockOsd
    },
    currentSn: '',
    currentType: -1
  },
  osdVisible: { // osd 显示设备相关信息
    sn: '',
    callsign: '',
    model: '',
    visible: false,
    gateway_sn: '',
    is_dock: false,
    payloads: null
  } as OSDVisible,
  waylineInfo: {

  } as WaylineFile,
  dockInfo: {

  } as Device,
  hmsInfo: {} as {
    [sn: string]: DeviceHms[]
  },
  // 机场指令执行状态信息
  devicesCmdExecuteInfo: {
  } as DevicesCmdExecuteInfo,
  mqttState: null as any, // mqtt 实例
  clientId: '', // mqtt 连接 唯一客户端id
  skWaylineInfo: [], // 司空保存航线信息
  algorithmList: {},
  currentTask: '',
  waylineName: '',
  imageDiffProgress: null, // 图片对比进度
  waylineId: '', // 航线id
})

export type RootStateType = ReturnType<typeof initStateFunc>

const getters: GetterTree<RootStateType, RootStateType> = {
}
const mutations: MutationTree<RootStateType> = {
  SET_IMAGE_DIFF_PROGRESS (state, info) {
    state.imageDiffProgress = info
  },
  SET_SELECT_WAYLINE_ID (state, info) {
    state.waylineId = info
  },
  SET_ALGORITHM_LIST (state, info) {
    state.algorithmList = info
  },
  SET_SELECT_WAYLINE_NAME (state, info) {
    state.waylineName = info
  },
  SET_CURRENT_TASK (state, info) { // 当前任务号ID
    state.currentTask = info
  },
  SET_SIDEBAR_ROUTERS (state, info) {
    console.log('SET_SIDEBAR_ROUTERS', info)
    state.sidebarRouters = info
  },
  SET_SK_WAYLINE_INFO (state, info) {
    state.skWaylineInfo = info
  },
  SET_LAYER_INFO (state, info) {
    state.Layers = info
  },
  SET_DEVICE_POWER (state, power) {
    state.isPowered = power
  },
  SET_DEVICE_INFO (state, info) {
    state.deviceState.deviceInfo[info.sn] = mergeAircraftTelemetry(state.deviceState.deviceInfo[info.sn], info.host)
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Aircraft
    if (info.host.mode_code === 9) {
      sessionStorage.removeItem('isOpenAI')
      if (!sessionStorage.getItem('is_back')) {
        sessionStorage.setItem('is_back', '1')
        if (sessionStorage.getItem('algorithm_task_list')) {
          const task_list = JSON.parse(sessionStorage.getItem('algorithm_task_list') || '[]')
          task_list.forEach(el => {
            if (el.openTask) {
              setAlgorithmTaskStatus({
                taskNo: el.taskNo,
                taskStatus: 0
              }).then(res => {
                if (res.data.code === 0) {
                  // sessionStorage.removeItem("algorithm_task_list")
                }
              })
            }
          })
        }
      }
    }
    if (info.host.mode_code === 10 || info.host.mode_code === 11) {
      state.algorithmList = {}
      if (sessionStorage.getItem('is_fly') || sessionStorage.getItem('is_back')) {
        sessionStorage.removeItem('is_back')
        // sessionStorage.removeItem('algorithm_task_list')
        sessionStorage.removeItem('is_fly')
        localStorage.removeItem('taskNo')
        sessionStorage.removeItem('is_fly_video')
      }
      if (sessionStorage.getItem('rainfall')) {
        sessionStorage.removeItem('rainfall')
      }
    }
  },
  SET_GATEWAY_INFO (state, info) {
    state.deviceState.gatewayInfo[info.sn] = info.host
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Gateway
  },
  SET_AIRCRAFT_DETAIL_STATE (state, info) {
    if (!info?.sn || !info?.host) return
    state.deviceState.deviceInfo[info.sn] = mergeAircraftTelemetry(state.deviceState.deviceInfo[info.sn], info.host, Date.now(), false)
  },
  SET_DOCK_INFO (state, info) {
    if (!info?.sn || !info?.host || !Object.keys(info.host).length) return
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Dock
    state.deviceState.dockInfo[info.sn] = mergeDockTelemetry(state.deviceState.dockInfo[info.sn], info.host)
  },
  SET_DRAW_VISIBLE_INFO (state, bool) {
    state.drawVisible = bool
  },
  SET_LIVESTREAM_OTHERS_VISIBLE (state, bool) {
    state.livestreamOthersVisible = bool
  },
  SET_LIVESTREAM_AGORA_VISIBLE (state, bool) {
    state.livestreamAgoraVisible = bool
  },
  SET_MAP_ELEMENT_CREATE (state, info) {
    state.wsEvent.mapElementCreat = info
  },
  SET_MAP_ELEMENT_UPDATE (state, info) {
    state.wsEvent.mapElementUpdate = info
  },
  SET_SPEAKER_AUDIO (state, info) {
    state.speakerAudio = info
  },
  SET_SPEAKER_VOLUME (state, info) {
    state.speakerVolume = info
  },
  SET_MAP_ELEMENT_DELETE (state, info) {
    state.wsEvent.mapElementDelete = info
  },
  SET_DEVICE_ONLINE (state, info) {
    state.deviceStatusEvent.deviceOnline = info
    // state.isPowered = true
  },
  SET_DEVICE_OFFLINE (state, info) {
    state.deviceStatusEvent.deviceOffline = info
    // state.isPowered = false
    delete state.deviceState.gatewayInfo[info.sn]
    delete state.deviceState.deviceInfo[info.sn]
    delete state.deviceState.dockInfo[info.sn]
    delete state.hmsInfo[info.sn]
    // delete state.markerInfo.coverMap[info.sn]
    // delete state.markerInfo.pathMap[info.sn]
  },
  SET_DEVICE_CLOSE (state, info) {
    delete state.deviceState.deviceInfo[info.sn]
  },
  SET_OSD_VISIBLE_INFO (state, info) {
    state.osdVisible = info
  },
  SET_SELECT_WAYLINE_INFO (state, info) {
    state.waylineInfo = info
  },
  SET_SELECT_DOCK_INFO (state, info) {
    state.dockInfo = info
  },
  SET_DEVICE_HMS_INFO (state, info) {
    if (!info?.sn) return
    const incoming: Array<DeviceHms> = Array.isArray(info.host) ? info.host : []
    const current: Array<DeviceHms> = state.hmsInfo[info.sn] ?? []
    const seen = new Set<string>()
    state.hmsInfo[info.sn] = incoming.concat(current).filter((hms: DeviceHms) => {
      const key = String(hms?.key ?? hms?.hms_id ?? '')
      if (!key || seen.has(key)) return false
      seen.add(key)
      return true
    })
  },
  SET_DEVICE_HMS_SNAPSHOT (state, info) {
    if (!info?.sn) return
    state.hmsInfo[info.sn] = Array.isArray(info.host) ? info.host : []
  },
  CLEAR_DEVICE_HMS_INFO (state) {
    state.hmsInfo = {}
  },
  SET_DEVICES_CMD_EXECUTE_INFO (state, info) { // 保存设备指令ws消息推送
    if (!info.sn) {
      return
    }
    if (state.devicesCmdExecuteInfo[info.sn]) {
      const index = state.devicesCmdExecuteInfo[info.sn].findIndex(cmdExecuteInfo => cmdExecuteInfo.biz_code === info.biz_code)
      if (index >= 0) {
        // 丢弃前面的消息
        if (state.devicesCmdExecuteInfo[info.sn][index].timestamp > info.timestamp) {
          return
        }
        state.devicesCmdExecuteInfo[info.sn][index] = info
      } else {
        state.devicesCmdExecuteInfo[info.sn].push(info)
      }
    } else {
      state.devicesCmdExecuteInfo[info.sn] = [info]
    }
  },
  SET_MQTT_STATE (state, mqttState) {
    state.mqttState = mqttState
  },
  SET_CLIENT_ID (state, clientId) {
    state.clientId = clientId
  },
}

const actions: ActionTree<RootStateType, RootStateType> = {
  async getAllElement ({ commit }) {
    const result = await getLayers({
      groupId: '',
      isDistributed: true
    })
    commit('SET_LAYER_INFO', result.data?.list)
    console.log(result)
  },
  updateElement ({ state }, content: {type: 'is_check' | 'is_select', id: string, bool:boolean}) {
    const key = content.id.replaceAll('resource__', '')
    const type = content.type
    const layers = state.Layers
    const layer = layers.find(item => item.id === key)
    if (layer) {
      layer[type] = content.bool
    }
  },
  setLayerInfo ({ state }, layers) {
    // const layers = state.Layers
    const obj:{
      [key:string]:string
    } = {}
    layers.forEach(layer => {
      if (layer.type === LayerType.Default) {
        obj.default = layer.id
      } else {
        if (layer.type === LayerType.Share) {
          obj.share = layer.id
        }
      }
    })
    state.layerBaseInfo = obj
    console.log('state.layerBaseInfo', state.layerBaseInfo)
  },
  getLayerInfo ({ state }, id:string) {
    return state.layerBaseInfo[id]
  },
  GenerateRoutes ({
    commit
  }) {
    return new Promise(resolve => {
      const menu = enhanceBackendMenuList(readStoredMenuList())
      const sidebarRoutes = buildAsyncRoutes(menu as BackendMenuNode[])

      commit('SET_SIDEBAR_ROUTERS', sidebarRoutes)

      resolve(sidebarRoutes)
    })
  }
}
const storeOptions: StoreOptions<RootStateType> = {
  state: initStateFunc,
  getters,
  mutations,
  actions
}

const rootStore = createStore(storeOptions)

export default rootStore

export const storeKey: InjectionKey<Store<RootStateType>> = Symbol('')

type AllStateStoreTypes = RootStateType & {
  // moduleName: moduleType
}

export function useMyStore<T = AllStateStoreTypes> () {
  return useStore<T>(storeKey)
}
